"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// NOTE styles for `a` and `hr` are added just to be overridable by setting colors in theme

const styleOverrides = {
  root: ({
    theme
  }) => ({
    // Scrollbar
    '@media (hover: hover) and (pointer: fine)': {
      '&, & *': {
        msOverflowStyle: '-ms-autohiding-scrollbar',
        scrollbarWidth: 'thin',
        scrollbarColor: `${theme.palette.grey[300]} transparent`
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar, & *::-webkit-scrollbar': {
        width: '15px',
        height: '15px'
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[300],
        borderRadius: '13px',
        border: '5px solid transparent',
        backgroundClip: 'content-box'
      }
    }
  })
};
var _default = exports.default = {
  styleOverrides
};
